import { Col, Row, Modal, Form, Switch, message } from "antd";
import { useTranslation } from "react-i18next";
import Title from "../../UI/Title/Title";
import { useState, useEffect, Dispatch } from "react";
import { UseMutateAsyncFunction, useMutation } from "react-query";
import AddEditModal from "../../UI/ModalComponent/AddEditModal/addeditcomponent";
import { AxiosResponse } from "axios";
import InputName from "../../UI/InputNumberComponent/InputName";
import { InputNumbers } from '../../UI/InputNumberComponent/NumericInput'

import { createDelivery, editDelivery } from "../../../api/refDelivery";
import { DeliveryType } from "./deliveryType";

type propsType = {
  component?: DeliveryType | undefined;
  openDelivery: boolean;
  setOpenDelivery: React.Dispatch<React.SetStateAction<boolean>>;
  id?: string | number;
  page: number;
  filter: boolean | undefined;
  search: string;
  setPaginatedtDelivery: Dispatch<any>;
  getDeliveriesMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
      q: string;
      isActive?: boolean | undefined;
    },
    unknown
  >;
};

export const AddEditDelivery = ({
  openDelivery,
  setOpenDelivery,
  id,
  component,
  page,
  search,
  filter,
  setPaginatedtDelivery,
  getDeliveriesMutation,
}: propsType) => {
  const [open, setOpen] = useState(false);
  const [t] = useTranslation("common");
  const [form] = Form.useForm();
  const [, setError] = useState("");
  const [location, setLocation] = useState(false);
  const [amount, setAmount] = useState(false);
  const [isActive, setIsActive] = useState<boolean>(
    component ? component?.isActive : true
  );
  const isEdit = () => {
    return !!id;
  };

  const [editStatus] = useState(isEdit());

  const onError = (error: any, variables: DeliveryType, context: unknown) => {
    if (setError) {
      setError(error.response.data.message);
      message.error({
        content: error.response.data.message,
        duration: 10,
        onClick: () => {
          message.destroy();
        },
      });
    }
  };
  const { mutate: mutateCreateUpdate, isLoading: isSaving } = useMutation(
    !isEdit() ? "createDelivery" : "editDelivery",
    !isEdit()
      ? (component: DeliveryType) => createDelivery(component)
      : (component: DeliveryType) => editDelivery(id, component),
    {
      onSuccess: (res) => {
        setOpen(false);
        setOpenDelivery(false);
        message.success(res.data.message);
        getDeliveriesMutation({
          q: search,
          isActive: filter,
          limit: page * 8 + 8,
        }).then((res: any) => {
          setPaginatedtDelivery(res.data?.data);
        });
      },
      onError,
    }
  );

  const handleLocationChange = (event: any) => {
    setLocation(event);
  };

  const handleAmountChange = (event: any) => {
    setAmount(event)
  }

  const handleFinish = () => {
    const newComponent = form.getFieldsValue();
    for (const key in newComponent) {
      if (newComponent[key] === undefined) {
        if (key === "isActive") {
          newComponent[key] = true;
        } else {
          newComponent[key] = null;
        }
      } else if (
        typeof newComponent[key] === "string" &&
        newComponent[key].trim() === ""
      ) {
        newComponent[key] = null;
      }
    }
    mutateCreateUpdate(newComponent);
  };

  useEffect(() => {
    if (editStatus) {
      setLocation(true);
    }
  }, [editStatus]);

  return (
    <>
      <Modal
        closable={false}
        maskClosable={false}
        width={490}
        centered
        open={openDelivery}
        onCancel={() => setOpenDelivery(false)}
        cancelText={t("cancel")}
        okButtonProps={{
          style: {
            height: "40px",
            width: "100px",
            color: "#fff",
            backgroundColor: !form.getFieldValue('location') || !form.getFieldValue('amount') ? "gray" : "#1677FF"
          },
          disabled: !form.getFieldValue('location') || !form.getFieldValue('amount'),
        }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        okText={isEdit() ? `${t("save")}` : `${t("add")}`}
        onOk={() => {
          setOpen(true);
        }}
      >
        <Title
          title={isEdit() ? `${t("edit-location")}` : `${t("add-location")}`}
        />
        {isEdit() && (
          <span className="modaltitleEdit">
            {t("edit-details-for")} {component?.location}
          </span>
        )}
        <Form
          layout="vertical"
          form={form}
          id="LocationForm"
          onFinish={handleFinish}
        >
          <Row>
            <Col span={14} style={{ marginTop: "20px" }}>
              <Form.Item
                initialValue={component?.location}
                name="location"
                label={t("location")}
                rules={[
                  {
                    required: true,
                    message: `${t("location-is-required")}`
                  },
                ]}
              >
                <InputName maxLength={50} onChange={handleLocationChange} />
              </Form.Item>
              <Form.Item
                initialValue={component?.amount}
                name="amount"
                label={t("amount") + " (" + JSON.parse(localStorage.getItem("mainCurrency") || '').symbol + ")"}
                rules={[
                  {
                    required: true,
                    message: `${t("amount-is-required")}`,
                  },
                ]}
              >
                <InputNumbers maxLength={50} onChange={handleAmountChange} />
              </Form.Item>
              <Form.Item name="isActive" label={`${t("status")}`}>
                <Switch
                  checkedChildren={`${t("active")}`}
                  unCheckedChildren={`${t("inactive")}`}
                  checked={isActive}
                  disabled={isEdit() ? false : true}
                  onChange={(num: boolean) => {
                    setIsActive(num);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <AddEditModal
        form="LocationForm"
        open={open}
        setOpen={setOpen}
        name={<span>{component?.location}</span>}
        title={`${t("modal-delivery")}`}
        id={id}
        isSaving={isSaving}
      />
    </>
  );
};
